package com.trevorwiebe.timesheet.core.domain

import kotlin.math.roundToLong

/** Formats a value with thousands separators and a single decimal place. */
fun Double.formatOneDecimal(): String {
    val totalTenths = (this * 10).roundToLong()
    val whole = totalTenths / 10
    val tenths = totalTenths % 10
    return "${whole.formatWithCommas()}.$tenths"
}

/** Formats a value with thousands separators and two decimal places. */
fun Double.formatTwoDecimals(): String {
    val totalHundredths = (this * 100).roundToLong()
    val whole = totalHundredths / 100
    val hundredths = totalHundredths % 100
    return "${whole.formatWithCommas()}.${hundredths.toString().padStart(2, '0')}"
}